import { showLogout, logout } from "../services/logout-service";
import { ErrorType } from "./ErrorType";
import { getAuthStatus, AuthenticationStatus } from "../services/authenticator-service";

export const fetchWrapper = async (
  ...fetchParams: Parameters<typeof fetch>
): Promise<{ result?: unknown; err?: unknown }> => {
  try {
    const fetchResult = await fetch(...fetchParams);

    if (fetchResult.ok) {
      return { result: await fetchResult.json() };
    }

    if (fetchResult.status === 401) {
      // Fetch failed with Unauthorized error
      if ((await getAuthStatus()) === AuthenticationStatus.LoggedOut) {
        // We are already logged out so don't do it again
        return { err: ErrorType.Unauthorized };
      }

      await showLogout();
      await logout();

      return { err: ErrorType.Unauthorized };
    }

    // Handle non-OK responses
    const err: unknown = await fetchResult.json().catch(() => fetchResult.text().catch(() => "Failed to fetch"));

    return { err: typeof err === "object" ? JSON.stringify(err, null, 2) : err };
  } catch (e) {
    return { err: e };
  }
};
